/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderfree2Inputs */

const en_ticketsorderfree2 = /** @type {(inputs: Ticketsorderfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_ticketsorderfree2 = /** @type {(inputs: Ticketsorderfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Ticketsorderfree2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderfree2 = /** @type {((inputs?: Ticketsorderfree2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderfree2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderfree2(inputs)
	return de_ticketsorderfree2(inputs)
});
export { ticketsorderfree2 as "ticketsOrderFree" }